"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpSensorStream = void 0;
var DataRef_1 = require("../api/DataRef");
var SkillRef_1 = require("../api/SkillRef");
var IdentityOp_1 = require("../api/IdentityOp");
var HttpSensorStream = /** @class */ (function () {
    function HttpSensorStream(url, credentials, gaiaStreamClientFactory) {
        this.client = gaiaStreamClientFactory.http(url + '/api')
            .withCredentials(credentials)
            .build();
    }
    HttpSensorStream.prototype.data = function (uri) {
        return new DataRef_1.DataRef(uri, this.client);
    };
    HttpSensorStream.prototype.skill = function (skillUri) {
        return new SkillRef_1.SkillRef(skillUri, this.client);
    };
    HttpSensorStream.prototype.identity = function () {
        return new IdentityOp_1.IdentityOp(this.client);
    };
    return HttpSensorStream;
}());
exports.HttpSensorStream = HttpSensorStream;
//# sourceMappingURL=HttpSensorStream.js.map